import { render, staticRenderFns } from "./Test.vue?vue&type=template&id=07411f7b&scoped=true"
import script from "./Test.vue?vue&type=script&lang=js"
export * from "./Test.vue?vue&type=script&lang=js"
import style0 from "./Test.vue?vue&type=style&index=0&id=07411f7b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07411f7b",
  null
  
)

export default component.exports